import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../hooks/usePageTitle';
import { SMSPageHeader as PageHeader } from '../components/layout/SMSPageHeader';
import { HiBolt } from 'react-icons/hi2';
import { EventsOverview } from '../components/events/EventsOverview';

export function Events() {
  const { t } = useTranslation();
  usePageTitle(t('events.title', 'Events'));
  return (
    <Box mx={-8} mt={-8}>
      <PageHeader
        icon={HiBolt}
        title={t('events.title', 'Events')}
        subtitle={t('events.subtitle', 'Active and historical reunification events and drills.')}
        showSearch={true}
        showNotifications={true}
      />

      <EventsOverview />
    </Box>
  );
}
